module.exports = __webpack_public_path__ + "img/galeria-insectos-1.d9c5ca21.jpg";